module.exports = __webpack_public_path__ + "img/recruiment-hover.074e7679.svg";